import { EventEmitter } from '@angular/core';
import { TimeSelectorComponent } from '@progress/kendo-angular-dateinputs';

export { GeneaInputsModule } from './genea-inputs.module';
export { required } from './validation/required';

export interface DropDownItem {
    Id?: number | string | boolean;
    Name?: string;
}